<div class="profile-page">

  <h2>{{ t('myProfile') }}</h2>

  <!-- 🆕 "Loading..." টেক্সট দেখানো বন্ধ করা হলো — এখন ফর্মটা শুরু
       থেকেই দেখায়, শুধু data না আসা পর্যন্ত input গুলো disabled
       থাকে আর কোণায় ছোট্ট একটা spinner (কোনো লেখা ছাড়া) ঘোরে। -->
  <div class="profile-card" [class.is-loading]="loading">

    <div class="profile-item">
      <label>{{ t('fullNameLabel') }}</label>

      <input
        type="text"
        [(ngModel)]="fullName"
        [disabled]="loading"
        [placeholder]="t('enterYourFullName')">
    </div>

    <div class="profile-item">
      <label>{{ t('emailLabel') }}</label>

      <input
        type="email"
        [value]="email"
        readonly>
    </div>

    <div class="profile-item">
      <label>{{ t('phoneLabelForm') }}</label>

      <input
        type="text"
        [(ngModel)]="phone"
        [disabled]="loading"
        [placeholder]="t('enterPhoneNumberForm')">
    </div>

    <div class="profile-item">
      <label>{{ t('addressLabelForm') }}</label>

      <textarea
        rows="4"
        [(ngModel)]="address"
        [disabled]="loading"
        [placeholder]="t('enterYourAddress')">
      </textarea>
    </div>

    <button
      class="save-btn"
      [disabled]="loading"
      (click)="saveProfile()">
      {{ t('saveProfile') }}
    </button>

    <div class="profile-spinner" *ngIf="loading" aria-hidden="true"></div>

  </div>

</div>